// 📁 hooks/useBottomNavHeight.js
import { useEffect, useState } from "react";

export const useBottomNavHeight = () => {
  const [bottomNavHeight, setBottomNavHeight] = useState(0);

  useEffect(() => {
    const nav = document.querySelector('.MuiBottomNavigation-root');
    if (nav) {
      const updateHeight = () => setBottomNavHeight(nav.offsetHeight);
      updateHeight();
      window.addEventListener('resize', updateHeight);
      return () => window.removeEventListener('resize', updateHeight);
    }
  }, []);

  return bottomNavHeight;
};
